import {
  Actions,
  CLEAN_WORKSHEETS_USING_SPACE_TYPE,
  DECREASE_POSITIONABLE_PS_DIALOG_COUNTER,
  GET_WORKSHEETS_USING_SPACE_TYPE_SUCCEDED,
  INCREASE_POSITIONABLE_PS_DIALOG_COUNTER,
} from 'spw-redux/modules/program-summary/programming/actions';
import { IProgrammingProgramSummaryState } from 'spw-redux/modules/program-summary/programming/types';
import {
  CLEAN_UP_CURRENT_PROJECT,
  cleanUpCurrentProject,
} from 'spw-redux/modules/projects/actions';

const initialState: IProgrammingProgramSummaryState = {
  worksheetsUsingSpaceType: null,
  positionablePSDialogCounter: 0,
};

const reducer = (
  state: IProgrammingProgramSummaryState = initialState,
  action: Actions | ReturnType<typeof cleanUpCurrentProject>
) => {
  switch (action.type) {
    case GET_WORKSHEETS_USING_SPACE_TYPE_SUCCEDED:
      return {
        ...state,
        worksheetsUsingSpaceType: action.payload.worksheets,
      };

    case CLEAN_WORKSHEETS_USING_SPACE_TYPE:
      return {
        ...state,
        worksheetsUsingSpaceType: null,
      };

    case INCREASE_POSITIONABLE_PS_DIALOG_COUNTER:
      return {
        ...state,
        positionablePSDialogCounter: state.positionablePSDialogCounter + 1,
      };

    case DECREASE_POSITIONABLE_PS_DIALOG_COUNTER:
      return {
        ...state,
        positionablePSDialogCounter: state.positionablePSDialogCounter - 1,
      };
    case CLEAN_UP_CURRENT_PROJECT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
